import React, { memo } from 'react'

const IconStaff = ({ color = "white", ...props }) => (
    <svg {...props} width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4 5.00156C12.4 7.15547 10.6539 8.90156 8.5 8.90156C6.34609 8.90156 4.6 7.15547 4.6 5.00156C4.6 2.84765 6.34609 1.10156 8.5 1.10156C10.6539 1.10156 12.4 2.84765 12.4 5.00156Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M1 18.9516C1 15.7207 3.61913 13.1016 6.85 13.1016H10.15C13.3809 13.1016 16 15.7207 16 18.9516C16 20.0285 15.127 20.9016 14.05 20.9016H2.95C1.87304 20.9016 1 20.0285 1 18.9516Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
);

export default memo(IconStaff);